
import { IMyHomepagePost } from '@/types';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'HomepageBoardProductList',
})
export default class extends Vue {
  @Prop({ required: true }) private postList!: IMyHomepagePost[]

  @Prop({ required: true }) private listQuery!: any

  @Prop({ required: true }) private listTotal!: number

  get imageUrl() {
    return `${process.env.VUE_APP_COMMON_API}/attached-file`;
  }
}
